<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
        <ConfermaModal
            v-if="confirmDelete"
            :backdrop="false"
            :visible="confirmDelete"
            @reject="confirmDelete = false"
            @confirm="performDelete"
        >
        </ConfermaModal>
        <CercaModal v-if="cercaModalVisibility"
                    back
                    @reject="cercaModalVisibility = false"
                    @confirm="cerca"
        ></CercaModal>
    </teleport>

    <div @click="cm_visible = -1" class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="flex justify-between items-center py-10">
                <h3 class="text-3xl">{{ labelGender }} <span class="font-bold">{{ me.name }}</span></h3>
                <NextButton component="router-link" v-if="hasPermission('create aziende') && rubrica === 0" :to="{name: 'NuovoCliente'}" variant="primary"
                            class="w-44 ml-3 text-sm py-2 px-4 m-0">
                    + Aggiungi
                </NextButton>
            </div>
            <HomeAlertBar
                :ok="meCounters.ok"
                :scaduti="meCounters.scaduti"
                :in_scadenza="meCounters.in_scadenza"
                :contatti="meCounters.contatti"
                :clienti="meCounters.clienti"
            ></HomeAlertBar>
            <div class="flex justify-between items-center py-10 gap-4">
                <h3 class="text-3xl font-bold">
                    {{ ["I miei clienti", "I miei contatti", 'Tutti i clienti', 'Tutti i contatti'][rubrica] }}</h3>
                <div class="grow grid grid-cols-2 items-center">
                    <div class="flex flex-col grow">
                        <Field :labelVisible="false"
                               v-model="search"
                               placeholder="Cerca"></Field>
                    </div>
                    <div>
                        <i @click="cercaModalVisibility = !cercaModalVisibility"
                           class="pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"></i>
                    </div>
                </div>
                <Switcher v-model="rubrica" :options="getSwitchOptions"></Switcher>
            </div>
            <div v-if="rubrica===0">
                <div class="flex justify-between">
                    <LegendaStatiCliente></LegendaStatiCliente>
                    <Paginator :pagination="listaMyClienti.paginate"></Paginator>
                </div>
                <div class="flex items-end rotate-x-180 overflow-x-scroll min-h-[250px]">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed"
                               :cols="clientiCols" :rows="listaMyClienti.rows"
                               @order-update="listaMyClienti.updateCols">

                        <template v-for="(c, j) in listaMyClienti.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            <router-link :to="{name:'DettaglioAzienda', params:{id:context.context.row.id}}"
                                         class="block text-center inset-0 absolute flex items-center justify-center">
                                <i class="icon-chevron_destra"></i>
                            </router-link>
                        </template>
                        <template v-for="(c, j) in listaMyClienti.rows" :key="j" v-slot:[`td_${j}_0`]="{context}">
                            <TableTooltip :inner_class="context.cell.td_class">{{
                                    context.row[context.cell.prop]
                                }}
                            </TableTooltip>
                        </template>
                        <template v-for="(c, j) in listaMyClienti.rows" :key="j" v-slot:[`td_${j}_1`]="{context}">
                            <TableTooltip :inner_class="context.cell.td_class">{{
                                    context.row[context.cell.prop]
                                }}
                            </TableTooltip>
                        </template>
                        <template v-for="(c, j) in listaMyClienti.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            <TabellaContextMenu
                                menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                                buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                                :context="c"
                                :id="j"
                                teleport_to="#modal"
                                :cmOpener="cmOpener"
                            >
                                <router-link :to="{name:'Attivita', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Attività
                                </router-link>
                                <router-link :to="{name:'Contatti', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Contatti
                                </router-link>
                                <span v-if="isNewBusiness" @click="cancellaAzienda(c.id)" class="text-next-orange">Elimina</span>
                            </TabellaContextMenu>

                        </template>
                        <template v-for="(c, j) in listaMyClienti.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                            {{ $filters.toDate(context.context.row.ultimo_contatto) }}
                        </template>
                        <template v-for="(c, j) in listaMyClienti.rows" :key="j" v-slot:[`td_${j}_2`]="{context}">
                            <div class="grid gap-1"
                                 :style="{'grid-template-columns': `repeat(${businessUnits.length}, minmax(0, 1fr))`}">
                                <div v-for="bu in businessUnits" class="tooltip-activator relative cursor-pointer"
                                     :key="bu.id">
                                    <div class="border border-next-neu rounded text-center text-xs">
                                        {{ bu.label }}
                                    </div>
                                    <div :class="`bg-next-${getColoriStati(context.row.stati[bu.id])}`"
                                         class="border rounded text-center text-xs text-white">
                                        {{ getLabel(context.row.stati[bu.id]) }}
                                    </div>
                                    <Tooltip>{{ getTooltip(context.row.stati[bu.id]) }}</Tooltip>
                                </div>
                            </div>
                        </template>
                    </NextTable>
                </div>
                <InfiniteLoading @infinite="listaMyClienti.fetchNextPage"
                                 :identifier="listaMyClienti.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else-if="rubrica===1">
                <div class="flex justify-end">
                    <Paginator :pagination="listaMyContatti.paginate"></Paginator>
                </div>
                <div class="flex items-end rotate-x-180 overflow-x-scroll min-h-[250px]">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4"
                               v-model:cols="contattiCols"
                               :rows="listaMyContatti.rows"
                               @order-update="listaMyContatti.updateCols">

                        <template v-for="(c, j) in listaMyContatti.rows" :key="j" v-slot:[`td_${j}_7`]>
                            <router-link :to="{name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center">
                                <i class="icon-chevron_destra"></i>
                            </router-link>
                        </template>

                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaMyContatti.fetchNextPage"
                                 :identifier="listaMyContatti.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri contatti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else-if="rubrica===2">
                <div class="flex justify-between">
                    <LegendaStatiCliente></LegendaStatiCliente>
                    <Paginator :pagination="listaClienti.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 table-fixed w-full border-separate border-spacing-3 py-4"
                               v-model:cols="clientiCols"
                               :pagination="listaClienti.paginate"
                               :rows="listaClienti.rows" @order-update="listaClienti.updateCols">
                        <template v-for="(c, j) in listaClienti.rows" :key="j" v-slot:[`td_${j}_0`]="{context}">
                            <TableTooltip :inner_class="context.cell.td_class">{{
                                    context.row[context.cell.prop]
                                }}
                            </TableTooltip>
                        </template>
                        <template v-for="(c, j) in listaClienti.rows" :key="j" v-slot:[`td_${j}_1`]="{context}">
                            <TableTooltip :inner_class="context.cell.td_class">{{
                                    context.row[context.cell.prop]
                                }}
                            </TableTooltip>
                        </template>

                        <template v-for="(c, j) in listaClienti.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            <router-link :to="{name:'DettaglioAzienda', params:{id:context.context.row.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                        </template>
                        <template v-for="(c, j) in listaClienti.rows" :key="j" v-slot:[`td_${j}_5`]>
                            <TabellaContextMenu
                                menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                                buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                                :context="c"
                                :id="j"
                                teleport_to="#modal"
                                :cmOpener="cmOpener"
                            >
                                <router-link :to="{name:'Attivita', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Attività
                                </router-link>
                                <router-link :to="{name:'Contatti', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Contatti
                                </router-link>
                                <span v-if="isNewBusiness" @click="cancellaAzienda(c.id)" class="text-next-orange">Elimina</span>
                            </TabellaContextMenu>
                        </template>
                        <template v-for="(c, j) in listaClienti.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                            {{ $filters.toDate(context.context.row.ultimo_contatto) }}
                        </template>
                        <template v-for="(c, j) in listaClienti.rows" :key="j" v-slot:[`td_${j}_2`]="{context}">
                            <div class="grid gap-1"
                                 :style="{'grid-template-columns': `repeat(${businessUnits.length}, minmax(0, 1fr))`}">
                                <div v-for="bu in businessUnits" class="tooltip-activator relative cursor-pointer"
                                     :key="bu.id">
                                    <div class="border border-next-neu rounded text-center text-xs">
                                        {{ bu.label }}
                                    </div>
                                    <div :class="`bg-next-${getColoriStati(context.row.stati[bu.id])}`"
                                         class="border rounded text-center text-xs text-white">
                                        {{ getLabel(context.row.stati[bu.id]) }}
                                    </div>
                                    <Tooltip>{{ getTooltip(context.row.stati[bu.id]) }}</Tooltip>
                                </div>
                            </div>
                        </template>
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaClienti.fetchNextPage" :identifier="listaClienti.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else>
                <div class="flex justify-end">
                    <Paginator :pagination="listaContatti.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4"
                               v-model:cols="contattiCols"
                               :rows="listaContatti.rows"
                               @order-update="listaContatti.updateCols">

                        <template v-for="(c, j) in listaContatti.rows" :key="j" v-slot:[`td_${j}_7`]>
                            <router-link :to="{name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center">
                                <i class="icon-chevron_destra"></i>
                            </router-link>
                        </template>
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaContatti.fetchNextPage" :identifier="listaContatti.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri contatti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import Topbar from "../components/Topbar.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import meManager from "../api/Me";
import {AlertState, ColoriStati, LabelStati, NomiStato, TableOrder} from "@/types";
import HomeFiltered from "@/views/HomeFiltered.vue";
import HomeAlertBar from "@/components/HomeAlertBar.vue";
import businessUnitsManager from "../api/BusinessUnits";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenu from "@/components/ContextMenu.vue";
import ConfermaModal from "@/components/ConfermaModal.vue";
import {mapActions, mapGetters} from 'vuex';
import Loading from "@/components/Loading.vue";
import contattiManager from "../api/Contatti";
import TableTooltip from "@/components/TableTooltip.vue";
import Switcher from "@/components/Switcher.vue";
import clientiManager from "../api/Clienti";
import NextButton from "@/components/NextButton.vue";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Lista from "@/setup/ListaCerca";
import Field from "@/components/Field.vue";
import CercaModal from "@/views/CercaModal.vue";
import Tooltip from "@/components/Tooltip.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import LegendaStatiCliente from "@/components/LegendaStatiCliente.vue";

@Options({
    name: 'Dashboard',
    components: {
        LegendaStatiCliente,
        Tooltip,
        CercaModal,
        Field,
        TabellaContextMenu,
        Loading,
        ConfermaModal,
        HomeAlertBar,
        HomeFiltered,
        Paginator,
        Topbar,
        AlertCard,
        NextTable,
        InfiniteLoading,
        ContextMenu,
        Switcher,
        NextButton,
        TableTooltip
    },
    computed: {
        ...mapGetters([
            'me',
            'labelGender',
            'isNewBusiness',
            'hasPermission',
            'meCounters'
        ])
    },
    methods: {
        ...mapActions([
            'fetchCounters'
        ])
    }
})
export default class Dashboard extends Vue {
    fetchCounters!: any
    cmOpener: any = setup(() => ContextMenuOpener())
    EAlertState = AlertState
    cm_visible = -1
    confirmDelete = false
    deleteId = 0

    cercaModalVisibility = false
    search = ''

    stateFilter = 0
    businessUnits: never[] = []
    paginate: any = {}
    alert_counters = {
        ok: 0,
        clienti: 0,
        in_scadenza: 0,
        scaduti: 0,
        contatti: 0
    }

    rubrica = 0
    sort = ''
    sortContatti = ''
    loading = false
    me!: any;
    hasPermission!: any;

    listaMyClienti: any = setup(() => Lista(meManager, this.clientiCols))
    listaMyContatti: any = setup(() => Lista(contattiManager, this.contattiCols, contattiManager.myContatti))
    listaClienti: any = setup(() => Lista(clientiManager, this.clientiCols))
    listaContatti: any = setup(() => Lista(contattiManager, this.contattiCols))

    cerca(data: any) {
        this.cercaModalVisibility = false
        //@ts-ignore
        this.$router.push({name: 'Search', query: data})
    }

    get getSwitchOptions() {
        return [`I miei clienti (${this.me.my_clienti})`, `I miei contatti (${this.me.my_contatti})`, 'Tutti i clienti', 'Tutti i contatti']
    }

    @Watch('search')
    setFilter(new_val: any, old_val: any) {
        if(!old_val.length && this.rubrica == 0){
            this.rubrica = 2
        }
        this.listaMyClienti.search = new_val
        this.listaMyContatti.search = new_val
        this.listaClienti.search = new_val
        this.listaContatti.search = new_val
        this.searchTables()
    }

    getColoriStati(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return ColoriStati[ColoriStati.neu]
        }
        return ColoriStati[EnumStato]
    }

    getLabel(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return LabelStati[LabelStati.NEU]
        }
        return LabelStati[EnumStato]
    }

    getTooltip(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return NomiStato[LabelStati.NEU]
        }
        return NomiStato[EnumStato]
    }

    created(): void {
        this.loading = true
        Promise.all([businessUnitsManager.businessUnits({params:{crm: 1}}).then((response) => {
            this.businessUnits = response.data
        }),
            this.fetchCounters()]).finally(() => {
            this.loading = false
        })
    }

    resetTables(){
        this.listaMyClienti.reset();
        this.listaMyContatti.reset();
        this.listaClienti.reset();
        this.listaContatti.reset();
    }

    searchTables(){
        this.listaMyClienti.debounceSearch();
        this.listaMyContatti.debounceSearch();
        this.listaClienti.debounceSearch();
        this.listaContatti.debounceSearch();
    }

    mounted() {
        this.resetTables();
    }

    cancellaAzienda(id: number) {
        this.confirmDelete = true;
        this.deleteId = id;
    }

    performDelete() {
        clientiManager.delete(this.deleteId).then(() => {
            this.listaMyClienti.reset();
        }).finally(() => {
            this.confirmDelete = false
        })
    }

    clientiCols = [
        {
            name: 'Denominazione',
            prop: 'denominazione',
            ordProp: 'anagrafiche_denominazioni.denominazione',
            orderable: true,
            class: 'text-left min-w-350',
            td_class: 'w-full overflow-visible relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Settore commerciale',
            prop: 'settori_join',
            orderable: false,
            class: 'text-left min-w-350',
            td_class: 'w-full overflow-visible relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'denominazione',
            orderable: false,
            class: 'text-left min-w-next-stato w-next-stato whitespace-nowrap',
            td_class: 'bg-transparent',
            resizable: false
        },
        {
            name: 'Ultimo contatto',
            prop: 'created_at',
            orderable: true,
            class: 'text-left min-w-150 w-150 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        }
    ]

    contattiCols = [
        {
            name: 'Nome',
            prop: 'nome',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'h-10 px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Cognome',
            prop: 'cognome',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'h-10 px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Denominazione azienda',
            prop: 'denominazione_cliente',
            orderable: false,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Posizione lavorativa',
            prop: 'posizione_lavorativa',
            orderable: true,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Dipartimento',
            prop: 'dipartimento',
            orderable: true,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Numero di telefono',
            prop: 'telefono_1',
            orderable: false,
            class: 'text-left min-w-200 w-200 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Email',
            prop: 'email',
            orderable: true,
            class: 'text-left min-w-200 w-200 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
